import { useEffect, useState } from 'react'
import { PkItem } from 'src/features/stock-movements/StockMovementsTypes'
import { PkModal } from '../PkModal/PkModal'
import * as S from './PkModalReport.styles'
import {
  FormControl, FormControlLabel, Radio, RadioGroup, TextField,
} from '@mui/material'

enum ReportOptions {
  OPTION1 = 'PRODUTO/CAIXA NÃO ENCONTRADO NO PK',
  OPTION2 = 'ENDEREÇO DE GÔNGOLA INCORRETO',
  OPTION3 = 'Opção 3',
  CUSTOM = 'Outra'
}

interface Props {
  show: boolean
  item: PkItem
  buttonCancelAction: () => any
  buttonConfirmAction: (reportMessage: string) => any
  testId?: string
}

export const PkModalReport = ({
  show, item, buttonCancelAction, buttonConfirmAction, testId,
}: Props) => {
  const [radioReport, setRadioReport] = useState<ReportOptions>(ReportOptions.OPTION1)
  const [customReport, setCustomReport] = useState<string>('')
  const [error, setError] = useState<string>('')

  useEffect(() => {
    setRadioReport(ReportOptions.OPTION1)
    setCustomReport('')
    setError('')
  }, [show])

  const handleRadioReportChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRadioReport((event.target as HTMLInputElement).value as ReportOptions)
    setError('')
  }

  const confirmAction = () => {
    if (radioReport === ReportOptions.CUSTOM && !customReport) {
      setError('Você deve informar a divergência observada')
    } else {
      buttonConfirmAction(radioReport === ReportOptions.CUSTOM ? customReport : radioReport)
    }
  }

  return (
    <PkModal
      show={show}
      backgroundColor='#002D62'
      title='REPORTAR DIVERGÊNCIA'
      testId={testId}
      body={(
        <S.Container>
          <S.AddressBox>
            {item.bestPosition.address}
          </S.AddressBox>
          <S.ProductInfoBox>
            {item.productDescription.toUpperCase()}
          </S.ProductInfoBox>
          <S.BatchQuantity>
            {item.batches.reduce((sum, batch) => sum + batch.quantity, 0)} UNIDADES
          </S.BatchQuantity>
          <S.Info>
            Que tipo de divergência você observou?
          </S.Info>
          <FormControl>
            <RadioGroup
              name='radio-buttons-report'
              value={radioReport}
              onChange={handleRadioReportChange}
            >
              <FormControlLabel value={ReportOptions.OPTION1} control={<Radio />} label={ReportOptions.OPTION1} />
              <FormControlLabel value={ReportOptions.OPTION2} control={<Radio />} label={ReportOptions.OPTION2} />
              <FormControlLabel value={ReportOptions.OPTION3} control={<Radio />} label={ReportOptions.OPTION3} />
              <FormControlLabel
                sx={{ width: '400px' }}
                value={ReportOptions.CUSTOM}
                control={<Radio />}
                label={(
                  <TextField
                    onKeyPress={() => null}
                    label={ReportOptions.CUSTOM}
                    size='small'
                    sx={{ width: '400px' }}
                    disabled={radioReport !== ReportOptions.CUSTOM}
                    onChange={(e) => setCustomReport(e.target.value)}
                    value={customReport}
                    error={!!error}
                    helperText={error}
                  />
                )}
              />
            </RadioGroup>
          </FormControl>
        </S.Container>
    )}
      cancelButtonText='Cancelar'
      cancelButtonColor='#FF8F1F'
      cancelButtonHoverColor='#BB6815'
      confirmButtonText='Reportar'
      confirmButtonColor='#1983DA'
      confirmButtonHoverColor='#1264A7'
      onReject={buttonCancelAction}
      onClose={buttonCancelAction}
      onConfirm={confirmAction}
    />
  )
}
